import { render, staticRenderFns } from "./iconComputer.vue?vue&type=template&id=5988ed63&scoped=true"
import script from "./iconComputer.vue?vue&type=script&lang=js"
export * from "./iconComputer.vue?vue&type=script&lang=js"
import style0 from "./iconComputer.vue?vue&type=style&index=0&id=5988ed63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988ed63",
  null
  
)

export default component.exports